
// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Button,
//   Spinner,
//   Alert,
//   Modal,
// } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import styles from "./SchoolRequestsPage.module.css";
// import api from "../../../../utils/ApiMethod";
// import { AppDispatch, RootState } from "../../../../redux/store";
// import { useDispatch, useSelector } from "react-redux";

// interface SchoolRequest {
//   // _id: { $oid: string };
//   _id: string;
//   fromClusterName: string;
//   Udise_Code: string;
//   email: string;
//   mob: string;
//   requestedBy: { $oid: string };
//   accepted: boolean;
//   rejectionReason: string;
//   pulled: boolean;
//   // createdAt: { $date: string };
//   createdAt: string; // Assuming createdAt is a string field
//   updatedAt: { $date: string };
//   __v: number;
//   status: string; // Assuming status is a string field
// }

// const SchoolRequestsPage: React.FC = () => {
//   const [requests, setRequests] = useState<SchoolRequest[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [error, setError] = useState<string | null>(null);
//   const [pullSchool, setpullSchool] = useState<boolean>(false);
//   const [showModal, setShowModal] = useState<boolean>(false);
//   const [modalMessage, setModalMessage] = useState<string>("");
//   const [modalVariant, setModalVariant] = useState<"success" | "danger">(
//     "success"
//   );

//   const { user } = useSelector((state: RootState) => ({
//     user: state.Auth.user,
//   }));

//   let profileId = user?._id ?? user?.user?._id ?? "";
//   const Key_Key = user?.moniterd_ttl ?? user?.user?.moniterd_ttl ?? "";

//   const FetchPullRequestByClusterName = async () => {
//     setLoading(true);
//     try {
//       const response = await api.fetchDataAuth(
//         `api/v5/requestforpull/${user?.clusterName}/${profileId}/${Key_Key}`
//       );
//       setRequests(response.data.data);
//       setLoading(false);
//       console.log("Pull School Response:", response);
//     } catch (error) {
//       console.error("Error fetching team data:", error);
//       setError("Failed to fetch school requests. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const PullSchoolByUdise = async (udiseCode: string) => {
//     console.log("Pulling school with UDISE Code:", udiseCode);
//     setpullSchool(true);
//     try {
//       const payload = {
//         udiseCode: udiseCode,
//       };
//       const response = await api.updatePatchAnyData(
//         `api/v5/bulk-pull-cluster/${profileId}/${Key_Key}`,
//         payload
//       );
//       console.log(
//         "response.status === 400:----------",
//         response.status,
//         response.status === 400
//       );

//       if (response.status === 200 || response.status === 201) {
//         setModalMessage("School pulled successfully!");
//         setModalVariant("success");
//         setShowModal(true);
//         await FetchPullRequestByClusterName(); // Refetch data to update the UI
//       } else if (response.status === 400) {
//         setModalMessage(`${response.data.message}`);
//         setModalVariant("danger");
//         setShowModal(true);
//       } else {
//         throw new Error("Failed to pull school");
//       }
//     } catch (error) {
//       console.error("Error pulling school:", error);
//       setModalMessage("Pull request not accepted yet or does not exist");
//       setModalVariant("danger");
//       setShowModal(true);
//     } finally {
//       setpullSchool(false);
//     }
//   };

//   const handlePullSchool = async (udiseCode: string) => {
//     await PullSchoolByUdise(udiseCode);
//   };

//   useEffect(() => {
//     FetchPullRequestByClusterName();
//   }, []);

//   if (loading) {
//     return (
//       <Container className={`text-center my-5 ${styles.h1}`}>
//         <Spinner animation="border" variant="primary" />
//         <p>Loading school requests...</p>
//       </Container>
//     );
//   }

//   if (error) {
//     return (
//       <Container className="my-5">
//         <Alert variant="danger">{error}</Alert>
//       </Container>
//     );
//   }

//   return (
//     <>
//       <Container fluid className={`py-1 bg-light ${styles.container}`}>
//         <h1 className={`text-center mb-1 ${styles.h1}`}>
//           School Transfer Requests
//         </h1>
//         <Row xs={1} md={2} lg={3} className="g-4">
//           {requests.map((request) => (
//             <Col key={request._id}>
//               <Card
//                 className={`${styles.card} shadow-sm h-100 border-0 ${styles.cardHover}`}
//               >
//                 <Card.Body className={styles.cardBody}>
//                   <div className={styles.header}>
//                     <Card.Title className={`${styles.cardTitle} text-primary`}>
//                       {request.fromClusterName}
//                     </Card.Title>
//                     <span className={styles.statusBadge}>
          
//                       {request.status && (
//                         <span
//                           className={
//                             request.status === "Pending"
//                               ? styles.statusPending
//                               : request.status === "Rejected"
//                               ? styles.statusRejected
//                               : styles.statusAccepted
//                           }
//                         >
//                           {request.status}
//                         </span>
//                       )}
//                     </span>
//                   </div>
//                   <Card.Text className={styles.cardText}>
//                     <div className={styles.detail}>
//                       <span className={styles.label}>UDISE Code:</span>
//                       <span>{request.Udise_Code}</span>
//                     </div>
//                     {request.rejectionReason && (
//                       <div className={styles.detail}>
//                         <span className={styles.label}>Rejection Reason:</span>
//                         <span className={`text-danger`}>{request.rejectionReason}</span>
//                       </div>
//                     )}
//                     <div className={styles.detail}>
//                       <span className={styles.label}>Pulled:</span>
//                       <span
//                         className={
//                           request.pulled
//                             ? styles.statusAccepted
//                             : styles.statusNotPulled
//                         }
//                       >
//                         {request.pulled ? "Yes" : "No"}
//                       </span>
//                     </div>
//                     <div className={styles.detail}>
//                       <span className={styles.label}>Created:</span>
//                       <span>
//                         {new Date(request.createdAt).toLocaleDateString()}
//                       </span>
//                     </div>
//                   </Card.Text>
//                   {!request.pulled && (
//                     <Button
//                       variant="primary"
//                       className={`${styles.btnPrimary} mt-3`}
//                       onClick={() => handlePullSchool(request.Udise_Code)}
//                       disabled={
//                         pullSchool ||
//                         request.pulled ||
//                         request.status !== "Accepted"
//                       }
//                     >
//                       {pullSchool ? (
//                         <>
//                           <Spinner
//                             as="span"
//                             animation="border"
//                             size="sm"
//                             role="status"
//                             aria-hidden="true"
//                             className="me-2"
//                           />
//                           Pulling...
//                         </>
//                       ) : (
//                         "Pull School"
//                       )}
//                     </Button>
//                   )}
//                 </Card.Body>
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       </Container>

//       {/* Modal for API Response */}
//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         centered
//         className={styles.modal}
//       >
//         <Modal.Body
//           className={
//             modalVariant === "success" ? styles.modalSuccess : styles.modalError
//           }
//         >
//           <div className={styles.modalContent}>
//             <span className={styles.modalIcon}>
//               {modalVariant === "success" ? "✅" : "❌"}
//             </span>
//             <p>{modalMessage}</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer className={styles.modalFooter}>
//           <Button
//             variant={modalVariant === "success" ? "success" : "danger"}
//             onClick={() => setShowModal(false)}
//             className={styles.modalButton}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default SchoolRequestsPage;


import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
  Modal,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./SchoolRequestsPage.module.css";
import api from "../../../../utils/ApiMethod";
import { AppDispatch, RootState } from "../../../../redux/store";
import { useDispatch, useSelector } from "react-redux";

interface SchoolRequest {
  _id: string;
  fromClusterName: string;
  Udise_Code: string;
  email: string;
  mob: string;
  requestedBy: { $oid: string };
  accepted: boolean;
  rejectionReason: string;
  pulled: boolean;
  createdAt: string;
  updatedAt: { $date: string };
  __v: number;
  status: string;
}

const SchoolRequestsPage: React.FC = () => {
  const [requests, setRequests] = useState<SchoolRequest[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [pullingSchools, setPullingSchools] = useState<{ [key: string]: boolean }>({}); // Map of UDISE codes to their loading states
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [modalVariant, setModalVariant] = useState<"success" | "danger">("success");

  const { user } = useSelector((state: RootState) => ({
    user: state.Auth.user,
  }));

  let profileId = user?._id ?? user?.user?._id ?? "";
  const Key_Key = user?.moniterd_ttl ?? user?.user?.moniterd_ttl ?? "";

  const FetchPullRequestByClusterName = async () => {
    setLoading(true);
    try {
      const response = await api.fetchDataAuth(
        `api/v5/requestforpull/${user?.clusterName}/${profileId}/${Key_Key}`
      );
      setRequests(response.data.data);
      setLoading(false);
      console.log("Pull School Response:", response);
    } catch (error) {
      console.error("Error fetching team data:", error);
      setError("Failed to fetch school requests. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const PullSchoolByUdise = async (udiseCode: string) => {
    console.log("Pulling school with UDISE Code:", udiseCode);
    setPullingSchools((prev) => ({ ...prev, [udiseCode]: true })); // Set loading state for this UDISE code
    try {
      const payload = {
        udiseCode: udiseCode,
      };
      const response = await api.updatePatchAnyData(
        `api/v5/bulk-pull-cluster/${profileId}/${Key_Key}`,
        payload
      );
      // console.log(
      //   "response.status === 400:----------",
      //   response.status,
      //   response.status === 400
      // );

      if (response.status === 200 || response.status === 201) {
        setModalMessage("School pulled successfully!");
        setModalVariant("success");
        setShowModal(true);
        await FetchPullRequestByClusterName(); // Refetch data to update the UI
      } else if (response.status === 400) {
        setModalMessage(`${response.data.message}`);
        setModalVariant("danger");
        setShowModal(true);
      } else {
        throw new Error("Failed to pull school");
      }
    } catch (error) {
      console.error("Error pulling school:", error);
      setModalMessage("Pull request not accepted yet or does not exist");
      setModalVariant("danger");
      setShowModal(true);
    } finally {
      setPullingSchools((prev) => ({ ...prev, [udiseCode]: false })); // Reset loading state for this UDISE code
    }
  };

  const handlePullSchool = async (udiseCode: string) => {
    await PullSchoolByUdise(udiseCode);
  };

  useEffect(() => {
    FetchPullRequestByClusterName();
  }, []);

  if (loading) {
    return (
      <Container className={`text-center my-5 ${styles.h1}`}>
        <Spinner animation="border" variant="primary" />
        <p>Loading school requests...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="my-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <>
      <Container fluid className={`py-1 bg-light ${styles.container}`}>
        <h1 className={`text-center mb-1 ${styles.h1}`}>
          School Transfer Requests
        </h1>
        <Row xs={1} md={2} lg={3} className="g-4">
          {requests.map((request) => (
            <Col key={request._id}>
              <Card
                className={`${styles.card} shadow-sm h-100 border-0 ${styles.cardHover}`}
              >
                <Card.Body className={styles.cardBody}>
                  <div className={styles.header}>
                    <Card.Title className={`${styles.cardTitle} text-primary`}>
                      {request.fromClusterName}
                    </Card.Title>
                    <span className={styles.statusBadge}>
                      {request.status && (
                        <span
                          className={
                            request.status === "Pending"
                              ? styles.statusPending
                              : request.status === "Rejected"
                              ? styles.statusRejected
                              : styles.statusAccepted
                          }
                        >
                          {request.status}
                        </span>
                      )}
                    </span>
                  </div>
                  <Card.Text className={styles.cardText}>
                    <div className={styles.detail}>
                      <span className={styles.label}>UDISE Code:</span>
                      <span>{request.Udise_Code}</span>
                    </div>
                    {request.rejectionReason && (
                      <div className={styles.detail}>
                        <span className={styles.label}>Rejection Reason:</span>
                        <span className={`text-danger`}>{request.rejectionReason}</span>
                      </div>
                    )}
                    <div className={styles.detail}>
                      <span className={styles.label}>Pulled:</span>
                      <span
                        className={
                          request.pulled
                            ? styles.statusAccepted
                            : styles.statusNotPulled
                        }
                      >
                        {request.pulled ? "Yes" : "No"}
                      </span>
                    </div>
                    <div className={styles.detail}>
                      <span className={styles.label}>Created:</span>
                      <span>
                        {new Date(request.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                  </Card.Text>
                  {!request.pulled && (
                    <Button
                      variant="primary"
                      className={`${styles.btnPrimary} mt-3`}
                      onClick={() => handlePullSchool(request.Udise_Code)}
                      disabled={
                        pullingSchools[request.Udise_Code] ||
                        request.pulled ||
                        request.status !== "Accepted"
                      }
                    >
                      {pullingSchools[request.Udise_Code] ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          Pulling...
                        </>
                      ) : (
                        "Pull School"
                      )}
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Modal for API Response */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className={styles.modal}
      >
        <Modal.Body
          className={
            modalVariant === "success" ? styles.modalSuccess : styles.modalError
          }
        >
          <div className={styles.modalContent}>
            <span className={styles.modalIcon}>
              {modalVariant === "success" ? "✅" : "❌"}
            </span>
            <p>{modalMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button
            variant={modalVariant === "success" ? "success" : "danger"}
            onClick={() => setShowModal(false)}
            className={styles.modalButton}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SchoolRequestsPage;